import React from 'react';
import {
    Card,
} from '@shopify/polaris';

class OperationStepCardComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            expanded: this.props.expanded
        }
    }

    render() {

        let body = (
            <React.Fragment>
                {this.props.showDescription && <Card.Section>
                    <p>{this.props.description}</p>
                </Card.Section>
                }
                <Card.Section>
                    {this.props.children}
                </Card.Section>
            </React.Fragment>);

        return (<Card subdued={this.props.disabled}
            title={this.props.title}
            footerActionAlignment="right"
            actions={[
                { content: 'Show/Hide', onAction: this.onToggleExpanded, disabled: this.props.disabled },

            ]}>

            {this.state.expanded && body}
            {!this.state.expanded && <br />}

        </Card>);
    }

    onToggleExpanded = () => {

        this.setState({
            expanded: !this.state.expanded
        });
    }

    componentDidMount() {
    }
}

OperationStepCardComponent.defaultProps = {
    title: 'Preview',
    description: "Description",
    showDescription: true,
    expanded: true,
    disabled: false,
}

export default OperationStepCardComponent;